// Optimized timeline data with memoization-friendly structure
export const timelineData = Object.freeze([
    Object.freeze({
        title: "Growing Up",
        backgroundColor: "#001122",
    }),
    Object.freeze({
        title: "High School", 
        backgroundColor: "#220011",
    }),
    Object.freeze({
        title: "College",
        backgroundColor: "#112200",
    }),
]);

// Pre-calculated constants for performance
export const TIMELINE_CONSTANTS = Object.freeze({
    TOTAL_PORTALS: timelineData.length,
    ANGLE_PER_PORTAL: (Math.PI * 2) / timelineData.length,
    CIRCLE_RADIUS: 8,
    PORTAL_SIZE: [4, 3],
    TRIGGER_POSITION: [-44, -5, 15],
    TRIGGER_SIZE: [20, 10, 20],
});

// Pre-calculated portal positions for better performance
export const getPortalPositions = () => {
    return timelineData.map((_, index) => {
        const angle = index * TIMELINE_CONSTANTS.ANGLE_PER_PORTAL;
        return Object.freeze({
            position: Object.freeze([
                Math.sin(angle) * TIMELINE_CONSTANTS.CIRCLE_RADIUS,
                1.5,
                Math.cos(angle) * TIMELINE_CONSTANTS.CIRCLE_RADIUS
            ]),
            rotation: Object.freeze([0, angle, 0])
        });
    });
};